// Used for MLB, NBA, NFL
import React, { memo } from 'react'
import { Box, CheckBox, Text, Image } from 'grommet'
import { intersectionBy } from '../../utils'

const ListItem = memo(
  ({
    item,
    selectedItems,
    availableItems,
    setSelectedItems,
    setAllSelectedItems,
  }) => {
    let values = [...selectedItems]

    const handleSelect = () => {
      const isAlreadySelected = values.some(
        selectedItem => selectedItem.name === item.name,
      )
      let updatedValues
      if (isAlreadySelected) {
        // If the item exists, remove it (uncheck)
        updatedValues = values.filter(
          selectedItem => selectedItem.name !== item.name,
        )
      } else {
        // If the item doesn't exist, add it (check)
        updatedValues = [...values, item]
      }
      setSelectedItems(updatedValues)

      // Set new choices
      values = updatedValues.slice(0)
      values = intersectionBy(
        values,
        availableItems,
        (v, u) => v.name === u.name,
      )
      setAllSelectedItems(values)
    }

    return (
      <Box
        key={item.name}
        direction="row"
        align="center"
        gap=".3rem"
        hoverIndicator={{ background: 'secondaryBg' }}
        pad={{ horizontal: '1rem', vertical: '0.5rem' }}
        height={{ min: '4.5rem' }}
        onClick={handleSelect}
      >
        <CheckBox
          checked={selectedItems.some(
            selectedItem => selectedItem.name === item.name,
          )}
        />
        <Image src={item.data} alt={item.name} width="24px" />
        <Text>{item.name}</Text>
      </Box>
    )
  },
)

export default ListItem
